import CollectionCard from './CollectionCard.container'

export default CollectionCard
